import React from 'react';

interface CustomIconCatiChart1Props extends React.SVGProps<SVGSVGElement> {}

export function CustomIconCatiChart1({ height, width, ...props }: CustomIconCatiChart1Props) {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path opacity="0.5" d="M4 8V11H7V8H4Z" fill="currentColor" />
      <path opacity="0.5" d="M4 16V20H7V16H4Z" fill="currentColor" />
      <path opacity="0.5" d="M4 4V7L20 7V4L4 4Z" fill="currentColor" />
      <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M14 11V8H20V11H14Z" fill="currentColor" />
      <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M8 11V8H13V11H8Z" fill="currentColor" />
      <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M8 15V12H13V15H8Z" fill="currentColor" />
      <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M14 15V12H20V15H14Z" fill="currentColor" />
      <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M14 20V16H20V20H14Z" fill="currentColor" />
      <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M8 20V16H13V20H8Z" fill="currentColor" />
      <path opacity="0.5" d="M4 12V15H7V12H4Z" fill="currentColor" />
      <path
        d="M11.3672 9.12646C11.4077 9.12655 11.4458 9.15145 11.4619 9.18799L12.4492 11.4917C12.4667 11.533 12.4548 11.5809 12.4199 11.6099L11.2773 12.5269C11.0754 12.6923 11.014 12.9752 11.1289 13.2095C11.9022 14.7843 13.1964 16.0789 14.7715 16.8521C14.9847 16.967 15.2894 16.9057 15.4551 16.7036L16.3926 15.5591C16.4186 15.5261 16.4672 15.5137 16.5078 15.5327L18.667 16.4575C18.7618 16.4981 18.8913 16.5537 18.8711 16.6548L18.4062 18.6685C18.3866 18.7536 18.3654 18.8731 18.2783 18.8735C13.2315 18.8735 8.49976 14.9995 9.12598 9.72119C9.12617 9.67253 9.1566 9.63465 9.2041 9.62354L10.4727 9.33057C10.5928 9.3028 11.2451 9.12646 11.3672 9.12646Z"
        fill="currentColor"
      />
    </svg>
  );
}
